<template>
  <v-autocomplete color="blue-darken-2"
                  variant="outlined"
                  density="compact"
                  flat
                  append-icon=""
                  v-bind="$attrs"
  >
    <template v-if="$slots.prepend" #prepend>
      <slot name="prepend"></slot>
    </template>

    <template v-slot:prepend-inner>
      <!-- @slot Inner prepend slot. Replaces the default icon slot -->
      <slot name="prepend-inner"></slot>
    </template>

    <template v-slot:item="{ props }">
      <!-- @slot Item slot. -->
      <slot name="item" v-bind="props"></slot>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'AppAutocomplete',
  inheritAttrs: false,
}
</script>
<style scoped lang="scss">
:deep(.v-input--horizontal .v-input__prepend) {
  margin: 0;
}
:deep(.v-field--variant-outlined .v-field__outline) {
  --v-field-border-opacity: .25;
  border-radius: 8px;
}
</style>
